import { GeoLang } from '@repo/ui/src/types';

export const MEATER_GEOS = [
  {
    productGeo: 'US',
    locale: 'en-US',
    name: 'United States',
    flag: '/assets/images/footer/flags/flag-us.svg',
    geoLoc: '/en-US',
    generalPage: 'general',
    isDefault: true,
    currency: 'USD',
    eCommEnabled: true,
    enableBazaarvoice: true,
  },
  {
    productGeo: 'CA',
    locale: 'en-CA',
    name: 'Canada',
    flag: '/assets/images/footer/flags/flag-ca.svg',
    geoLoc: '/en-CA',
    generalPage: 'general-en-ca',
    currency: 'CAD',
  },
  {
    productGeo: 'CA',
    locale: 'fr-CA',
    name: 'Canada (French)',
    flag: '/assets/images/footer/flags/flag-ca.svg',
    geoLoc: '/fr-CA',
    generalPage: 'general-fr-ca',
    currency: 'CAD',
  },
  {
    productGeo: 'GB',
    locale: 'en-US', // GB uses external site
    name: 'United Kingdom',
    flag: '/assets/images/footer/flags/flag-uk.svg',
    geoLoc: 'https://meater.co.uk',
    generalPage: 'general-en-gb',
    currency: 'GBP',
  },
  {
    productGeo: 'AU',
    locale: 'en-US', // AU uses external site
    name: 'Australia',
    flag: '/assets/images/footer/flags/flag-au.svg',
    geoLoc: 'https://meater.com.au',
    generalPage: 'general-en-au',
    currency: 'AUD',
  },
  {
    productGeo: 'NZ',
    locale: 'en-US',
    name: 'New Zealand',
    flag: '/assets/images/footer/flags/flag-nz.svg',
    geoLoc: 'https://meater.nz',
    generalPage: 'general-en-nz',
    currency: 'NZD',
  },
] as GeoLang[];

export const defaultGeo = MEATER_GEOS.find((geo) => geo.isDefault)!;

export const getGeoFromProductGeo = (productGeo: string) => {
  return MEATER_GEOS.find((c) => c.productGeo === productGeo) ?? null;
};
export const getGeoFromPath = (path: string) =>
  MEATER_GEOS.find((geo) => path.startsWith(geo.geoLoc)) ?? defaultGeo;
export const getGeoFromLocale = (locale: string) =>
  MEATER_GEOS.find((c) => c.locale === locale) ?? defaultGeo;
